import { configureStore, combineReducers } from "@reduxjs/toolkit";
import sessionStorage from "redux-persist/lib/storage/session"; // Import sessionStorage
import { persistReducer, persistStore } from "redux-persist";
import planValidityReducer from "./planValiditySlice";
import authReducer from "./authSlice";

// Combine your reducers
const rootReducer = combineReducers({
    planValidity: planValidityReducer,
    auth: authReducer,
});

// Configure persistence with sessionStorage
const persistConfig = {
    key: "root",
    storage: sessionStorage, // Use sessionStorage instead of localStorage
    whitelist: ["planValidity", "auth"], // Persist only these slices
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
    }),
});

// Create a persistor for session data
export const persistor = persistStore(store);
